import workflow from './ArtworkWorkflowNav.module.css'
export default function ArtworkWorkflowNav({label,steps,value,onChange,prefix,className=''}){
  return <nav className={`${workflow.nav} ${className}`} aria-label={label}>{steps.map(([id,name],i)=><button type="button" key={id} className="btn" aria-current={value===id?'step':undefined} aria-controls={`${prefix}-${id}`} onClick={()=>onChange(id)}><span>{i+1}</span>{name}</button>)}</nav>
}
